// app/components/productConstants.ts
export const categoryData: Record<string, { name: string; bgClass: string; icon: string }> = {
  prerolls: {
    name: 'Prerolls',
    bgClass: 'bg-catBlue',
    icon: '/icons/PREROLL.svg',
  },
  flower: {
    name: 'Flower',
    bgClass: 'bg-catGreen',
    icon: '/icons/FLOWER.svg',
  },
  vapes: {
    name: 'Vape',
    bgClass: 'bg-catOrange',
    icon: '/icons/CARTRIDGE.svg',
  },
  edibles: {
    name: 'Edibles',
    bgClass: 'bg-catPink',
    icon: '/icons/EDIBLE.svg',
  },
  concentrates: {
    name: 'Concentrates',
    bgClass: 'bg-catRed',
    icon: '/icons/EXTRACT.svg',
  },
  beverages: {
    name: 'Drinks',
    bgClass: 'bg-catPeach',
    icon: '/icons/All.svg', // Fallback—replace if you have a specific drinks icon.
  },
  topicals: {
    name: 'Topicals',
    bgClass: 'bg-catPurple',
    icon: '/icons/TOPICAL.svg',
  },
  tinctures: {
    name: 'Tinctures',
    bgClass: 'bg-catGrey',
    icon: '/icons/TINCTURE.svg',
  },
  merch: {
    name: 'Merch',
    bgClass: 'bg-catLimeGreen',
    icon: '/icons/MERCH.svg',
  },
  deals: {
    name: 'Deals',
    bgClass: 'bg-catLimeGreen',
    icon: '/icons/All.svg', // Fallback—adjust if necessary.
  },
};

export const defaultFilterGroups = [
  { title: 'Brand', options: [] },
  { title: 'Subtype', options: [] },
  { title: 'Classification', options: [] },
  { title: 'Size', options: [] },
  { title: 'Deal', options: [] },

];
